// extracted by mini-css-extract-plugin
export var formContainer = "_hn-0";
export var message = "_hn-1";